import { render, staticRenderFns } from "./LayoutDemo.vue?vue&type=template&id=2650dbb0&"
import script from "./LayoutDemo.vue?vue&type=script&lang=js&"
export * from "./LayoutDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports